module.exports = __webpack_public_path__ + "img/amulogo.97e41b9d.png";